import { CircularProgress, InputAdornment, TextField } from '@mui/material';

import FormField from 'components/common/formikForm/formField';

import { useCountryResidentialStatus } from 'hooks';
import { generateOptionsFromString } from 'utils/dataFormatter';

// Component to handle dynamic residency status fetching
export const ResidencyStatusField = ({
    countryOfResidence,
    disabled,
    required,
    name = 'residency_status',
    label = 'statusInCountryOfResidence',
}: {
    countryOfResidence: string;
    disabled?: boolean;
    required?: boolean;
    /** Formik field name (default residency_status). */
    name?: string;
    label?: string;
}) => {
    const { data: residencies, isLoading } = useCountryResidentialStatus(countryOfResidence);

    const residencyOptions = generateOptionsFromString(residencies ?? []);

    if (!countryOfResidence) {
        return <FormField type="autosuggest" name={name} label={label} options={[]} disabled />;
    }

    if (isLoading) {
        return (
            <TextField
                fullWidth
                disabled
                label={label}
                placeholder="Loading..."
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <CircularProgress size={20} />
                            </InputAdornment>
                        ),
                    },
                }}
            />
        );
    }

    return (
        <FormField
            type="autosuggest"
            name={name}
            label={label}
            options={residencyOptions}
            disabled={disabled}
            required={required}
        />
    );
};
